import { useEffect } from "react"
import { useDispatch } from "react-redux"
import {
    startMonitorAsyncOperations,
    stopMonitorAsyncOperations
} from "../Actions/API/AppInstance/AppInstanceActions"
import { APIAppAsyncOperationModel } from "../Models/API/APIAppAsyncOperationModel"
import { FetchState } from "../Models/Client/FetchState"
import { useAppState } from "./useReduxState"

export function useAppAsyncOperations(
    appID: string
): FetchState<APIAppAsyncOperationModel[]> {
    const dispatch = useDispatch()
    const fetchState = useAppState(
        state => state.api.apps.asyncOperation[appID]
    )

    useEffect(() => {
        dispatch(startMonitorAsyncOperations(appID))

        return () => {
            dispatch(stopMonitorAsyncOperations(appID))
        }
    }, [appID, dispatch])

    return fetchState
}
